module.exports = __webpack_public_path__ + "img/logo-yinxiang.b1f65e87.png";